import { Grid, IconButton, ListItemText, Paper } from "@material-ui/core";
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { isAuthorized } from "components/Authorize/authorizeUtil";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import CustomInput from "components/CustomInput";
import NotificationProvider from "components/NotificationProvider";
import { IconEdit } from "icons";
import { useState } from "react";
import { useUpdateClientAccountMutation } from "../../clientAccountSlice";
import { clientAccountLabels, clientAccountMessages, superDispatchCustomerIdPattern } from "../EditClientPopupConsts";
import { useClientAccountRowStyles } from "./ClientAccountRowStyles";

const isValidCustomerId = (customerId) => !customerId?.trim() || superDispatchCustomerIdPattern.test(customerId.trim());

const getSaveErrorMessage = (error) =>
    Array.isArray(error?.data) && error.data.length ? error.data.join(' ') : clientAccountMessages.SAVE_ERROR;

const ClientAccountRow = ({ account, canEditName = true }) => {
    const classes = useClientAccountRowStyles();

    const [updateClientAccount, { isLoading: isSaving }] = useUpdateClientAccountMutation();
    const [draft, setDraft] = useState(null);

    const canEditCustomerId = isAuthorized(permissionProfiles.CLIENT_CONFIG.CLIENT_CONFIG_SUPER_DISPATCH_CUSTOMER_ID);
    const customerIdValid = isValidCustomerId(draft?.superDispatchCounterpartyGuid);

    const onSave = async () => {
        const customerId = draft.superDispatchCounterpartyGuid?.trim();
        const result = await updateClientAccount({ subClient: { ...draft, superDispatchCounterpartyGuid: customerId || null } });
        if (result.error) {
            NotificationProvider.error(getSaveErrorMessage(result.error));
        } else {
            NotificationProvider.success(clientAccountMessages.SAVE_SUCCESS);
            setDraft(null);
        }
    };

    return (
        <Paper className={classes.paper}>
            {draft ?
                <Grid alignItems="center" container direction='row' justifyContent="space-between">
                    <Grid item xs={10}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={canEditCustomerId ? 6 : 12}>
                                {canEditName ?
                                    <CustomInput
                                        label={clientAccountLabels.SUB_CLIENT_NAME}
                                        elementType='input'
                                        value={draft.name}
                                        onChange={(name) => setDraft(current => ({ ...current, name }))}
                                    /> :
                                    <ListItemText primary={draft.name} />}
                            </Grid>
                            {canEditCustomerId &&
                                <Grid item xs={6}>
                                    <CustomInput
                                        label={clientAccountLabels.SUPER_DISPATCH_CUSTOMER_ID}
                                        elementType='input'
                                        value={draft.superDispatchCounterpartyGuid ?? ''}
                                        onChange={(customerId) => setDraft(current => ({ ...current, superDispatchCounterpartyGuid: customerId }))}
                                        valid={customerIdValid}
                                        touched
                                    />
                                    {!customerIdValid &&
                                        <div className={classes.errorText}>{clientAccountMessages.INVALID_SUPER_DISPATCH_CUSTOMER_ID}</div>}
                                </Grid>}
                        </Grid>
                    </Grid>
                    <Grid item className={classes.icons}>
                        <IconButton edge="end" size='small' onClick={onSave} disabled={!draft.name || !customerIdValid || isSaving}>
                            <CheckIcon />
                        </IconButton>
                        <IconButton edge='end' size='small' onClick={() => setDraft(null)}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid> :
                <Grid container direction='row' alignItems="center">
                    <ListItemText
                        primary={account.name}
                        secondary={canEditCustomerId ?
                            `${clientAccountLabels.SUPER_DISPATCH_CUSTOMER_ID}: ${account.superDispatchCounterpartyGuid || clientAccountLabels.NOT_SET}` :
                            null}
                    />
                    <Grid item className={classes.icons}>
                        <IconButton edge="end" size='small' onClick={() => setDraft(account)}>
                            <IconEdit />
                        </IconButton>
                    </Grid>
                </Grid>}
        </Paper>
    );
};

export default ClientAccountRow;
